import { decryptData2 } from './encryption-util';

export default async function fetchWhatsAppList(name, language) {
  const BASE_URL = process.env.NEXT_PUBLIC_API_PATH;
  const url = new URL(`${BASE_URL}/get-json-variable`);
  url.searchParams.set('name', name);
  url.searchParams.set('language', language);

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`WhatsApp API failed with status ${response.status}`);
  }

  const rawData = await response.text();

  // API returns: "<encrypted_string>:<something>"
  const parts = String(rawData).split(':');
  const decrypted = decryptData2(parts[0]);
  const parsed = JSON.parse(decrypted);

  if (parsed.status_code !== 1) {
    throw new Error('WhatsApp API returned invalid status');
  }

  return parsed.data.list;
}
